import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import type { AffiliateClick } from '@/hooks/affiliate/useAffiliateAnalytics';

interface TopPartnersChartProps {
  data: AffiliateClick[];
}

export const TopPartnersChart = ({ data }: TopPartnersChartProps) => {
  // Take top 10 partners
  const topPartners = data.slice(0, 10);

  return (
    <Card className="mt-6">
      <CardHeader>
        <CardTitle>Top Performing Partners</CardTitle>
        <CardDescription>Partners ranked by total clicks</CardDescription>
      </CardHeader>
      <CardContent>
        <ResponsiveContainer width="100%" height={400}>
          <BarChart data={topPartners} layout="vertical">
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis type="number" />
            <YAxis dataKey="partner_name" type="category" width={150} />
            <Tooltip />
            <Legend />
            <Bar 
              dataKey="clicks" 
              fill="hsl(var(--primary))" 
              name="Clicks"
            />
          </BarChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
};
